<template>

  <div>
    <div class="row  no-gutters pt-xl-4 mb-xl-6">
      <div class="col-xl-3 col-6 tab-test-bird order-xl-1 order-2">

      </div>
      <div class="col-xl-6 col-12 tab-test-title order-xl-2 order-1 text-center pt-xl-3 mt-xl-0 mt-4"
           v-if="lesson">
        {{ lesson.lesson }}
      </div>
      <div class="col-xl-3 col-6 tab-video-points test-line order-xl-3 order-3" v-if="points">
        <div class="zerno-points">
          {{ points }}
        </div>
      </div>
      <div class="col-xl-12 col-12 tab-video-notice order-xl-4 order-4 text-center mt-xl-n7 mt-n5 mb-xl-0 mb-3">
        <div class="tab-video-notice-1">{{ $t('test') }} {{ $t('№') }}{{ test.pos }}
          <span class="ml-2" v-if="testsCount > 0">({{ test.pos }} {{ $t('of') }} {{ testsCount }})</span>
        </div>
      </div>

      <div class="col-12 order-10 text-center" v-if="showTestIntro && test">

        <h2 class="mt-7" v-if="test.test">{{ test.test }}</h2>
        <h2 class="mt-7" v-else>{{ $t('test') }} {{ $t('№') }}{{ test.pos }}</h2>
        <h1 class="mb-5 mt-2" v-if="test.description">«{{ test.description }}»</h1>
        <button
            class="btn btn-success btn-large btn-lg mb-9 btn-to-next-lesson"
            @click="startTest">
          <i class="ni ni-spaceship mr-2"></i>{{ $t('start_test') }} {{ $t('№') }}{{ test.pos }}
        </button>

      </div>

      <div class="col-12 order-10" v-if="!showTestIntro && test">

        <div class="row ml-xl-0 mr-xl-0 ml-3 mr-3 justify-content-center">

          <div class="col-xl-12 col-12 test-question-content text-center mt-xl-n4"
               v-if="currentTask.testtask">
                        <span v-if="currentTask.pos && !currentTask.testtask.startsWith($t('№')+currentTask.pos)"
                              class="mr-3">{{ $t('№') }}{{ currentTask.pos }}.</span>{{ currentTask.testtask }}
          </div>

          <div class="col-12 tab-video-notice-2 text-center pl-xl-0 pl-6 pr-xl-0 pr-6 mb-xl-4"
               v-if="test.description && test.description !== currentTask.testtask">{{
              test.description
            }}
          </div>

          <div class="col-12 h3 text-center">Твое время: {{ timerText }}</div>
          <div v-if="result=='correct'" class="row">
            <div class="col-12 mb-4 text-center">
              <img src="poliimg/excellent.png"
                   class="test-image"
                   style="width: 250px"
              >
            </div>
          </div>
          <div v-else class="row justify-content-center mb-4">
            <div class="col-6 mb-xl-4 mb-4 mt-2">
              <div>
                <container
                    :orientation="'vertical'"
                    group-name="col"
                    :get-child-payload="index => {return this.testelements[index]}"
                    class="ma-4 row text-center align-content-center"
                    @drop="onDrop"
                >
                  <draggable
                      class="col-12 mx-auto"
                      v-for="child in testelements"
                      :key="child.idtestelement"
                  >
                    <div class="py-2">
                      <div class="justify-center ma-0 drop-word cursordefault">
                        {{ child.word }}
                      </div>
                    </div>
                  </draggable>
                </container>
              </div>
            </div>
            <div class="col-6">
              <div class="row">

                <div
                    v-for="(item,ind) in testelementsDropZone"
                    :key="'zone' + ind"
                    :class="['col-12']"
                >
                  <div :class="['d-flex', item.color]">
                    <div class="ma-0 pa-0">
                      <container
                          group-name="col"
                          :should-accept-drop="(src, payload) => {return testelementsDropZone[ind].child.length===0 || payload===testelementsDropZone[ind].child[0]}"
                          :get-child-payload="getCardPayload(ind)"
                          no-drag-class="card-ghost"
                          no-drop-class="card-ghost-drop"
                          :drop-placeholder="dropPlaceholderOptions"
                          class="text-right"
                          style="min-width: 100px; height: 50px;"
                          @drop="(e) => onCardDrop(ind, e)"
                      >
                        <draggable
                            v-for="child in testelementsDropZone[ind].child"
                            :key="child.idtestelement"
                        >
                          <div class="ma-3 py-2">
                            <div class="justify-center ma-0 pa-0 drop-word cursordefault">
                              {{ child.word }}
                            </div>
                          </div>
                        </draggable>
                      </container>
                    </div>
                    <div class="justify-center ma-0 py-2 drop-word">
                      {{ item.word2 }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="result=='wrong'" class="col-12 mt-2 text-center textred">Попробуй еще раз!</div>
          </div>


        </div>

      </div>


    </div>
    <div class="row mb-4 mt-1 justify-content-center no-gutters" v-if="!showTestIntro && test">
      <button
          class="btn btn-info"
          @click="skip"
      >
        {{ $t('omit_task') }} &rarr;
      </button>
    </div>
  </div>

</template>

<style src="@/assets/poliglotiki/main.css">
</style>
<script>
import api from '@/utils/api'
import {Container, Draggable} from 'vue-smooth-dnd'

export default {
  name: 'Test22',
  components: {
    Container,
    Draggable,
  },
  props: {
    idtest: {default: null},
    lesson: {type: Object, default: null},
    points: {default: null},
    testsCount: {default: null},
    showButtons: {type: Boolean, default: true},
  },
  data: () => ({
    test: {},
    testtasks: [],
    testelements: [],
    taskIdx: 0,
    audio: new Audio(),
    result: null,

    testelementsDropZone: [],

    timerSeconds: 0,
    timer: null,

    upperDropPlaceholderOptions: {
      className: 'cards-drop-preview',
      animationDuration: '150',
      showOnTop: true,
    },
    dropPlaceholderOptions: {
      className: 'drop-preview',
      animationDuration: '150',
      showOnTop: true,
    },

    showTestIntro: true,

    //errorChord: 'gong.mp3',
    errorChord: 'https://www.poliglotiki.ru/images/pol-mp3/error_chord.mp3',
    okChord: 'https://www.poliglotiki.ru/images/pol-mp3/ok.mp3',
  }),

  computed: {
    currentTask: function () {
      // console.log('currentTask')
      return (this.taskIdx < this.testtasks.length) ? this.testtasks[this.taskIdx] : {}
    },

    timerText() {
      const sec = this.timerSeconds % 60
      const min = Math.trunc(this.timerSeconds / 60)
      return min.toString().padStart(2, "0") + ':' + sec.toString().padStart(2, "0")
    },
  },

  watch: {
    taskIdx: function () {
      this.loadTask()
    },
  },

  async mounted() {
    api({url: '/tests/' + this.idtest}).then(resp => {
      this.test = resp.data
    })
    const response = await api({url: '/testtasks?sort=pos' + (this.idtest ? '&filter[idtest]=' + this.idtest : '')})
    this.testtasks = response.data
    // workaround for "once smooth-dnd is touched, can not scroll any more page" https://github.com/kutlugsahin/smooth-dnd/issues/83#issuecomment-713486752
    const cleanClasses = () => {
      document.body.className = '';
    };
    document.addEventListener('touchend', cleanClasses, false);
  },

  methods: {
    async startTest() {
      if (this.testtasks.length) {
        if (this.test.audio) {
          await this.play(this.test.audio)
        }
        this.showTestIntro = false
        this.loadTask()
      }
    },
    async loadTask() {
      this.result = null
      if (this.currentTask.idtesttask) {
        const response = await api({
          method: 'get',
          url: '/testelements?filter[idtesttask]=' + this.currentTask.idtesttask
        })
        this.testelements = response.data

        this.testelementsDropZone = []
        for (let index = 0; index < this.testelements.length; index++) {
          this.testelementsDropZone.push({
            idtestelement: this.testelements[index].idtestelement,
            word2: this.testelements[index].word2,
            child: []
          })
        }

        this.testelements = this.shuffle(this.testelements)
        this.startTimer()
      } else {
        this.$emit('testComplete')
      }
    },

    getBy(propname, value, array) {
      for (let index = 0; index < array.length; index++) {
        if (array[index][propname] === value) return array[index]
      }

      return {}
    },

    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]]
      }
      return a
    },

    play: function (path) {
      return new Promise((resolve) => {
        if (path) {
          this.audio.src = path
          this.audio.play()
          this.audio.onended = function () {
            console.log('Звук закончился')
            resolve()
          }

          this.audio.onerror = function () {
            console.log('Звук error')
            resolve()
          }
        } else {
          resolve()
        }
      })
    },

    skip: function () {
      this.$emit('wrongAnswer', {test: this.test.test, taskIdx: this.taskIdx, error: 'Пропущено'})
      this.taskIdx++
    },

    next: async function () {
      this.taskIdx++
    },

    onDrop(dropResult) {
      this.testelements = this.applyDrag(this.testelements, dropResult)
    },

    async onCardDrop(zoneIdx, dropResult) {
      // console.log('drop ' + zoneIdx, dropResult, this.testelementsDropZone)
      this.testelementsDropZone[zoneIdx].child = this.applyDrag(this.testelementsDropZone[zoneIdx].child, dropResult)

      if (dropResult.addedIndex === null) {
        this.testelementsDropZone[zoneIdx].color = 'textblack'
      } else if (dropResult.payload.idtestelement === this.testelementsDropZone[zoneIdx].idtestelement) {
        this.$emit('correctAnswer')
        this.testelementsDropZone[zoneIdx].color = 'textgreen'
        if (dropResult.payload.audio) {
          await this.play(dropResult.payload.audio)
        } else {
          await this.play(this.okChord)
        }
      } else {
        this.testelementsDropZone[zoneIdx].color = 'textred'
        this.result = 'wrong'
        const id = dropResult.payload.idtestelement

        setTimeout(() => {
          this.result = null
          this.testelementsDropZone[zoneIdx].color = ''
          this.testelementsDropZone[zoneIdx].child = []
          this.testelements.push(dropResult.payload)
        }, 1500)
        await this.play(this.errorChord)
      }

      let complete = true
      this.testelementsDropZone.forEach(function (zone) {
        if (zone.color !== 'textgreen') complete = false
      })

      if (complete) {
        this.result = 'correct'
        this.stopTimer()
        await this.sleep(3000)
        this.next()
      }
    },
    getCardPayload(zoneIdx) {
      // console.log('getCardPayload', zoneIdx)
      return index => {
        return this.testelementsDropZone[zoneIdx].child[index]
      }
    },
    dragStart() {
      // console.log('drag started')
    },
    log(...params) {
      console.log(...params)
    },

    applyDrag(arr, dragResult) {
      const {removedIndex, addedIndex, payload} = dragResult
      if (removedIndex === null && addedIndex === null) return arr

      const result = [...arr]
      let itemToAdd = payload

      if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0]
      }

      if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd)
      }

      return result
    },

    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    startTimer() {
      if (this.timer !== null) clearTimeout(this.timer)
      this.timerSeconds = 0
      this.timer = setInterval(() => {
        this.timerSeconds++
      }, 1000)
      console.log('start timer', this.timer)
    },

    stopTimer() {
      clearTimeout(this.timer)
      console.log('stop timer')
    },
  },

  destroyed() {
    this.stopTimer()
  },
}
</script>

<style scoped>
.textblack {
  color: black;
}

.textgreen {
  color: green;
}

.textred {
  color: red;
}

.cursordefault {
  cursor: default;
}

.smooth-dnd-container {
  min-height: 30px;
  width: 100%;
  padding: 0;
  margin: 0;
  display: inline-block !important;
}

.smooth-dnd-draggable-wrapper {
  display: inline-block !important;
}

.form-ghost {
  transition: 0.18s ease;
  box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.08);
}

.form-ghost-drop {
  box-shadow: 0 0 2px 5px rgba(0, 0, 0, 0.0);
}

.drop-preview {
  background-color: rgba(150, 150, 200, 0.1);
  border: 1px dashed #abc;
  margin: 5px;
}

.cards-drop-preview {
  background-color: rgba(150, 150, 200, 0.1);
  border: 1px dashed #abc;
  margin: 5px 45px 5px 5px;
}
</style>
